import { Text } from "@dropbox/dig-components/typography";
import { withShade } from "@dropbox/dig-foundations";
import { Link } from "@mirage/mosaics/BaseProfilePage/Link";
import { ReportCountBadge } from "@mirage/mosaics/BaseProfilePage/ReportCountBadge";
import { UserProfileAvatar } from "@mirage/mosaics/UserProfilePage/UserProfileAvatar";
import { getUserProfilePageHref } from "@mirage/mosaics/UserProfilePage/utils";
import cx from "classnames";
import type { LinkProps } from "react-router-dom";

import type { BasicUserInfo } from "@mirage/mosaics/UserProfilePage/types";
import styles from "./UserProfileCard.module.css";

interface ProfileCardProps {
  user: BasicUserInfo;
  target?: LinkProps["target"];
}

export const UserProfileCard = ({ user, target }: ProfileCardProps) => {
  const isDeactivated = !!user.is_deactivated;
  const directReportsCount = user.direct_report_count ?? 0;
  const totalReportsCount = user.total_report_count ?? 0;
  return (
    <>
      <Link
        to={getUserProfilePageHref(user.email) ?? ""}
        hasNoUnderline
        target={target}
        {...withShade({
          className: cx(styles.profileContainer, {
            [styles.deactivatedContainer]: isDeactivated,
          }),
        })}
      >
        <div className={styles.avatarContainer}>
          <UserProfileAvatar user={user} size="customize_large" />
          {directReportsCount && directReportsCount > 0 && totalReportsCount ? (
            <ReportCountBadge
              direct_report_count={directReportsCount}
              total_report_count={totalReportsCount}
            />
          ) : (
            <></>
          )}
        </div>
        <div className={styles.textContainer}>
          <Text
            isBold
            variant="label"
            className={cx({
              [styles.deactivatedName]: isDeactivated,
            })}
          >
            {user.name}
          </Text>
          <Text
            size="small"
            color="faint"
            variant="label"
            className={cx({
              [styles.deactivatedName]: isDeactivated,
            })}
          >
            {user.role}
          </Text>
        </div>
      </Link>
    </>
  );
};

export default UserProfileCard;
